import { render, staticRenderFns } from "./VideoAction.vue?vue&type=template&id=70cb273d&scoped=true&"
import script from "./VideoAction.vue?vue&type=script&lang=js&"
export * from "./VideoAction.vue?vue&type=script&lang=js&"
import style0 from "./VideoAction.vue?vue&type=style&index=0&id=70cb273d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cb273d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
